
import './EditProfileForm.scss';
export default function EditProfileForm(props: any) {
    return (
        <div className="sc-emjYpo esOxsZ ">
            <form className="sc-eXNvrr cfoAuu ">
                {props.children}
            </form>
        </div>
    );
}